import { Button, Field, Input, Skeleton } from "@platform/ui";
import { useConsole } from "../../context";
import { useT } from "../../i18n";
import { SettingErrors, useSetting } from "../../lib/use-setting";
import { ErrorBanner, PageCard, Section } from "../../layout/Page";

export function LogRetentionPage() {
  const { t } = useT();
  const { can } = useConsole();
  const s = useSetting("log-retention");
  if (s.query.isError)
    return (
      <PageCard>
        <ErrorBanner error={s.query.error} onRetry={() => void s.query.refetch()} />
      </PageCard>
    );
  if (!s.draft)
    return (
      <PageCard>
        <Skeleton className="m-6 h-24" />
      </PageCard>
    );
  const days = s.draft.days;
  const editable = can("settings:write");
  return (
    <PageCard>
      <SettingErrors state={s} conflictLabel={t("signin.conflict")} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          s.save.mutate({ days });
        }}
      >
        <Section title={t("nav.logRetention")}>
          <Field label={t("retention.days")} hint={t("retention.hint")}>
            {(p) => (
              <Input
                {...p}
                type="number"
                min={1}
                max={3650}
                disabled={!editable}
                className="max-w-40"
                value={days}
                onChange={(e) => s.setDraft({ days: Number(e.target.value) })}
              />
            )}
          </Field>
        </Section>
        {editable && (
          <div className="flex justify-end px-6 pb-5">
            <Button
              type="submit"
              data-testid="save-settings-button"
              loading={s.save.isPending}
              disabled={!(days >= 1 && days <= 3650)}
            >
              {t("common.save")}
            </Button>
          </div>
        )}
      </form>
    </PageCard>
  );
}
